export interface NewsItem {
  id: string;
  title: string;
  category: string;
  summary: string;
  content: string[];
  author: string;
  publishDate: string;
  cover: string;
}

export const newsCategories = [
  { key: "industry", name: "行业动态", desc: "聚焦影视市场的趋势、票房与产业最新变化。" },
  { key: "review", name: "影视评论", desc: "深度解读近期口碑作品，聊聊镜头里的故事。" },
  { key: "celebrity", name: "明星八卦", desc: "演员与创作者的最新动态与幕后花絮。" },
  { key: "preview", name: "新片预告", desc: "即将上映与定档作品的先导资讯抢先看。" },
];

export const news: NewsItem[] = [
  {
    id: "n1",
    title: "2026年春季档票房创新高，国产科幻再迎突破",
    category: "industry",
    summary:
      "据最新统计，本年度春季档总票房较去年同期上涨明显，其中科幻题材贡献了近三成份额，成为最大亮点。",
    content: [
      "多家票务平台日前公布的数据显示，本年度春季档总票房较去年同期实现明显增长，观影人次也同步回升。业内普遍认为，内容质量的整体提升是带动市场回暖的关键因素。",
      "在众多类型中，科幻题材表现尤为突出。以《星际回响》为代表的一批国产科幻作品，凭借扎实的剧本与不断精进的视效水平，赢得了观众与评论界的双重认可，贡献了整个档期近三成的票房份额。",
      "有分析人士指出，科幻类型的崛起并非偶然。近年来，国内影视工业在特效制作、美术设计、声音工程等环节持续投入，逐步建立起相对完整的制作体系，为大体量题材提供了坚实支撑。",
      "与此同时，观众对影片的要求也在提高。单纯依靠视觉奇观已难以持续吸引观众走进影院，故事本身的完成度与情感浓度，正成为决定口碑与长线票房的核心变量。",
      "展望后续档期，多位从业者表示，行业整体正从追求数量的阶段，转向更加注重品质与差异化的阶段。能否持续产出兼具观赏性与思想性的作品，将成为衡量一家影视公司长期竞争力的重要标准。",
    ],
    author: "影视产业观察",
    publishDate: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=Cinema%20auditorium%20with%20rows%20of%20empty%20red%20seats%20and%20large%20glowing%20screen%2C%20warm%20amber%20ambient%20light%2C%20cinematic%20industry%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-n1&orientation=landscape",
  },
  {
    id: "n2",
    title: "流媒体平台加码短剧赛道，内容生态持续升级",
    category: "industry",
    summary:
      "多家流媒体平台宣布加大对短剧内容的投入，从题材多样化到制作精细化，短剧正从“流量玩法”走向“内容竞赛”。",
    content: [
      "近期，多个主流流媒体平台相继公布新一轮内容计划，短剧成为其中被反复提及的关键词。与早期以低成本、强反转为主不同，如今的短剧正朝着题材多样化与制作精细化的方向演进。",
      "平台方表示，短剧的核心优势在于节奏紧凑、适应碎片化观看场景，但要真正留住用户，仍需在故事与人物上投入更多心思。为此，不少平台开始引入成熟编剧团队与专业制作流程，提升整体完成度。",
      "内容生态的升级也带来新的合作模式。传统影视公司与新兴制作团队之间的边界逐渐模糊，越来越多创作者以更灵活的机制参与其中，为短剧注入新的表达方式。",
      "不过，行业内部也保持理性。有从业者提醒，短剧不应被简单视为“低成本风口”，只有在内容质量与用户价值之间找到平衡，这一赛道才能走得更远。",
    ],
    author: "文娱前线",
    publishDate: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimal%20video%20production%20studio%20with%20monitors%20and%20warm%20studio%20lighting%2C%20clean%20professional%20technology%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-n2&orientation=landscape",
  },
  {
    id: "n3",
    title: "《暗夜追凶》：在类型片的框架里，写一封城市的情书",
    category: "review",
    summary:
      "它不是一部靠反转取胜的悬疑片，而是用犯罪的外壳，去描摹一座城市与生活在其中的人的孤独与温柔。",
    content: [
      "看完《暗夜追凶》，很难用“悬疑片”三个字概括它。影片当然有案件、有追凶、有层层推进的悬念，但真正让人记住的，是那些在霓虹与雨水之间一闪而过的人。",
      "导演周澈显然对城市有着细腻的观察。镜头反复游走在潮湿的街巷、深夜的便利店与空荡的公交站台之间，这些空间并不是背景，而是故事的另一个主角。它们安静地记录着每个人被生活磨过的痕迹。",
      "主角程野的中年疲惫，被演员演绎得克制而准确。他不再年轻，也不再确信自己能否赢，但正因为如此，他的每一次坚持才显得格外动人。影片没有把他塑造成英雄，而是让他成为一个仍然愿意认真对待自己职责的普通人。",
      "从技术层面看，影片的摄影与声音设计也相当出色。雨声、脚步声与远处车流的低鸣交织在一起，建立起一种持续的、几乎无处不在的紧张感，却又在关键时刻留出呼吸的空间。",
      "如果说类型的框架决定了这部影片能被多少人看见，那么影片中那些不动声色的情感，则决定了它能被记住多久。《暗夜追凶》证明，好的类型片从来不必牺牲真诚。",
    ],
    author: "影评人 · 南屿",
    publishDate: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20city%20alley%20at%20night%20with%20neon%20reflections%20on%20wet%20ground%2C%20moody%20teal%20and%20amber%20cinematic%20tone%2C%20film%20review%20editorial%20imagery%2C%20no%20text&width=800&height=450&seq=news-cover-n3&orientation=landscape",
  },
  {
    id: "n4",
    title: "《云上烟火》为何成为年度口碑黑马",
    category: "review",
    summary:
      "没有狗血冲突，没有流量堆砌，这部讲述普通人日常的都市情感剧，却成了许多人今年追得最认真的一部。",
    content: [
      "《云上烟火》几乎是悄无声息地开播，又几乎是靠观众口口相传火起来的。它没有大开大合的戏剧冲突，讲的是一间旧书店和一群街坊邻居的平凡日子。",
      "这样的题材在当下并不讨巧，但剧集凭借对生活细节的耐心还原，赢得了观众的信任。人物会为一顿饭认真准备，会为一句话别扭半天，也会在深夜鼓起勇气发出一条消息。这些微小的瞬间，恰恰构成了大多数人真实的生活。",
      "表演是这部剧的另一个加分项。林素饰演的女主角没有夸张的情绪爆发，更多时候只是安静地站在人群里，眼神里有疲惫，也有不愿放弃的柔软。这种克制，让角色显得格外可信。",
      "有观众评论说，看这部剧像在看自己的生活——谈不上惊心动魄，却总能在某个瞬间被击中。或许正是这种“被看见”的感觉，让它成为今年最难被忽视的黑马。",
    ],
    author: "影评人 · 纪小满",
    publishDate: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20old%20bookstore%20interior%20with%20sunlight%20and%20wooden%20shelves%2C%20amber%20and%20soft%20orange%20tone%2C%20gentle%20everyday%20life%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-n4&orientation=landscape",
  },
  {
    id: "n5",
    title: "实力派演员林知遥宣布时隔三年回归荧屏",
    category: "celebrity",
    summary:
      "在专注幕后创作多年后，演员林知遥确认将出演一部现实题材剧集，这也是他时隔三年再度担纲主演。",
    content: [
      "演员林知遥的工作室今日确认，他将出演一部现实题材剧集并担纲主演。这也是他自三年前转向幕后创作之后，首次以演员身份回归电视剧领域。",
      "据了解，该剧聚焦普通家庭的日常与代际关系，剧本打磨历时近两年。林知遥在采访中表示，正是剧本中那些克制的、不煽情的表达打动了他，“我想演一个会犯错、也会害怕的普通人。”",
      "过去三年，林知遥以导演和制片人身份参与多部作品，作品口碑稳定。此次回归荧屏，被不少观众视为年度最值得期待的表演之一。",
      "剧组透露，该剧预计将于明年上半年与观众见面，目前正在紧张筹备之中。",
    ],
    author: "娱乐追踪",
    publishDate: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20empty%20theater%20stage%20with%20single%20spotlight%20and%20deep%20blue%20curtains%2C%20dramatic%20theatrical%20mood%2C%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-n5&orientation=landscape",
  },
  {
    id: "n6",
    title: "新生代导演周澈携新作亮相国际电影节",
    category: "celebrity",
    summary:
      "导演周澈的最新作品入围某国际电影节主竞赛单元，成为本届少数入选的华语影片之一。",
    content: [
      "新生代导演周澈的最新作品日前确认入围某国际电影节主竞赛单元，成为本届少数入选的华语影片之一。消息公布后，迅速引发业内关注。",
      "周澈以细腻的现实主义风格著称，作品常聚焦城市中的普通个体。此次新作延续了他一贯的创作母题，但在叙事结构上做了更为大胆的尝试。",
      "在映后交流中，周澈表示，自己更关心的是“人如何在复杂的环境里保留一点体面”。“技术会过时，但人对人的理解不会，我想拍的是后者。”",
      "影片的海外发行计划也在同步推进中，预计将在电影节后陆续与各地观众见面。",
    ],
    author: "影像周报",
    publishDate: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=Festival%20red%20carpet%20entrance%20at%20night%20with%20warm%20golden%20lights%20and%20crowd%20silhouette%2C%20glamorous%20cinematic%20mood%2C%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-n6&orientation=landscape",
  },
  {
    id: "n7",
    title: "《星际回响》发布首支预告，视效震撼引热议",
    category: "preview",
    summary:
      "影片首支正式预告片上线后迅速登上热搜，宏大的宇宙场景与克制的叙事气质成为讨论焦点。",
    content: [
      "国产科幻电影《星际回响》今日发布首支正式预告片。短短两分钟的片段，展现了影片宏大的宇宙场景与细腻的情感线索，上线后迅速登上多个平台热搜。",
      "预告片中，孤独的探测器、无垠的星云与主角凝视远方的特写交替出现，配合极简的配乐，营造出一种克制的史诗感。不少观众评价其“视效惊喜、气质沉稳”。",
      "导演林知遥表示，影片并不追求密集的视觉刺激，而是希望通过大银幕的沉浸感，让观众真正体会到“孤独”与“寻找”这两个主题。",
      "影片目前已进入后期制作的最后阶段，具体上映日期将在后续公布。",
    ],
    author: "电影预告站",
    publishDate: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=Deep%20space%20nebula%20with%20distant%20spaceship%20and%20starlight%2C%20gold%20and%20deep%20blue%20cosmic%20clouds%2C%20epic%20science%20fiction%20cinematic%20mood%2C%20no%20text&width=800&height=450&seq=news-cover-n7&orientation=landscape",
  },
  {
    id: "n8",
    title: "《山海秘藏》定档暑期，古装奇幻再掀热潮",
    category: "preview",
    summary:
      "影片正式宣布定档，先导海报同步曝光，群山与异兽的意象引发观众对东方奇幻美学的期待。",
    content: [
      "古装奇幻电影《山海秘藏》正式宣布定档，片方同步发布了先导海报与幕后特辑。海报中，云雾环绕的群山与若隐若现的异兽剪影，勾勒出浓郁的东方奇幻气质。",
      "影片改编自古典山海意象的创作母题，讲述一位年轻地图绘制师为验证祖父遗愿而深入群山的故事。主创团队表示，影片在美术设计上大量参考了传统绘画的构图与用色。",
      "从幕后特辑来看，剧组搭建了大规模实景，并结合实体特效与数字技术，力求让想象中的世界具备可信的质感。",
      "片方表示，希望影片不仅是一场视觉冒险，也能传递关于传承与勇气的思考。",
    ],
    author: "电影预告站",
    publishDate: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=Misty%20ancient%20Chinese%20mountains%20with%20distant%20mythical%20creature%20silhouette%20in%20clouds%2C%20jade%20green%20and%20gold%20fantasy%20tone%2C%20epic%20landscape%2C%20no%20text&width=800&height=450&seq=news-cover-n8&orientation=landscape",
  },
  {
    id: "n9",
    title: "综艺观察：《奇遇厨房》如何做出久违的烟火气",
    category: "review",
    summary:
      "在一众快节奏综艺里，这档慢下来的美食真人秀，用一桌家常菜换来了少见的真诚。",
    content: [
      "《奇遇厨房》的设定简单到近乎朴素：四位常驻嘉宾每周去一位普通人的厨房做客，做一桌家常菜，聊一段生活故事。没有激烈的竞技，也没有刻意的剪辑冲突。",
      "但正是这种“慢”，成了它最大的辨识度。节目把大量镜头留给了洗菜、切菜、等待汤滚起来的时刻，这些看似无意义的细节，反而让屏幕前的观众感到放松。",
      "更难得的是节目对普通人的尊重。受访者不是被消费的“故事素材”，而是真正站在镜头中心的人。他们的讲述有大有小，但都带着生活本身的重量。",
      "在一众追求刺激的综艺里，《奇遇厨房》选择慢下来，选择相信烟火气的力量。这或许就是它能被反复讨论的原因。",
    ],
    author: "综艺观察员 · 竹一",
    publishDate: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=Rustic%20warm%20kitchen%20table%20with%20steaming%20homestyle%20dishes%20and%20fresh%20vegetables%2C%20warm%20orange%20wood%20tones%2C%20cozy%20cooking%20atmosphere%2C%20no%20text&width=800&height=450&seq=news-cover-n9&orientation=landscape",
  },
  {
    id: "n10",
    title: "国产剧集出海提速，东方故事走向全球",
    category: "industry",
    summary:
      "越来越多国产剧集通过海外平台与电影节走向国际观众，题材与叙事方式也在持续调整。",
    content: [
      "近年来，国产剧集的海外发行步伐明显加快。从古装历史到都市情感，不同题材的作品陆续登陆多个国家和地区的流媒体平台，观众群体不断扩大。",
      "业内人士分析，海外市场的拓展并非简单“搬运”。为了适应不同文化语境，制作方在翻译、配音与叙事节奏上做出了不少调整，力求让故事真正“被看懂”。",
      "与此同时，一些作品开始尝试与国际团队合作，在保留本土表达的前提下，吸收更成熟的工业经验。这种双向交流，正在悄然改变国产剧集的面貌。",
      "有从业者认为，出海的最终目的不是单纯的数量增长，而是让更多海外观众通过故事认识真实而立体的东方生活。",
    ],
    author: "影视产业观察",
    publishDate: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=World%20map%20made%20of%20glowing%20cinema%20film%20strips%20over%20dark%20blue%20background%2C%20global%20media%20concept%2C%20editorial%20technology%20imagery%2C%20no%20text&width=800&height=450&seq=news-cover-n10&orientation=landscape",
  },
  {
    id: "n11",
    title: "《极速边界》IMAX特辑曝光，实拍场面燃爆",
    category: "preview",
    summary:
      "片方发布 IMAX 幕后特辑，大量实拍赛车场面与精心设计的赛道细节首度公开。",
    content: [
      "动作电影《极速边界》今日发布 IMAX 幕后特辑，曝光了多场实拍赛车戏的拍摄过程。为追求真实质感，剧组在专业赛道完成了大量实车拍摄。",
      "特辑中可以看到，摄影团队使用了多机位与车拍系统，力求捕捉高速运动下的细节。主演也为角色进行了长时间的驾驶训练，多数镜头由本人完成。",
      "导演邵沉表示，实拍带来的不确定性与张力，是数字特效难以替代的。“观众能感受到轮胎与地面之间那种真实的力量。”",
      "影片目前已进入紧张的后期阶段，具体档期将在近期确定。",
    ],
    author: "电影预告站",
    publishDate: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=Race%20car%20on%20night%20circuit%20with%20light%20trails%20and%20sparks%2C%20orange%20and%20deep%20navy%20tone%2C%20high%20speed%20cinematic%20mood%2C%20no%20text&width=800&height=450&seq=news-cover-n11&orientation=landscape",
  },
  {
    id: "n12",
    title: "老戏骨陈立群获终身成就奖，台上致辞感动全场",
    category: "celebrity",
    summary:
      "在年度影视盛典上，资深演员陈立群获颁终身成就奖，其朴实的致辞打动在场所有同行。",
    content: [
      "在近日举行的年度影视盛典上，资深演员陈立群获颁终身成就奖。从艺数十年来，他塑造了众多令人难忘的角色，被誉为“教科书级的表演者”。",
      "上台领奖时，陈立群的致辞格外朴素。他说自己并不是天赋型的演员，只是比别人多了一点耐心，“一个角色，我愿意花一年去靠近他。”",
      "他同时勉励年轻同行，不必急于被看见，而要先把基本功练扎实。“观众的眼睛是亮的，你认真过多少，他们看得出来。”",
      "致辞结束后，全场起立鼓掌，久久不息。",
    ],
    author: "娱乐追踪",
    publishDate: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20stage%20with%20golden%20trophy%20and%20warm%20spotlights%2C%20solemn%20celebratory%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-n12&orientation=landscape",
  },
];